import React, { useState } from "react";
import Button from "../buttons/Button";
import Text from "../typography/Text";
import ImageSVG from "../../images/icons/image.svg";
import ImageCrop from "./ImageCrop";

export default ({ setFile, currentImage, label, notice, ...modifiers }) => {
  const [showCropModal, setCropModal] = useState(false);
  const [imageSrc, setImageSrc] = useState();
  const [imageCropped, setImageCropped] = useState();

  const imageRef = React.useRef();
  const btnRef = React.useRef();

  let className = `imageUpload -background ${currentImage ? "-filled" : ""}`;
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );

  // When user uploads an image, ask him to crop it
  const onChange = event => {
    const image = event.target.files[0];
    const reader = new FileReader();
    reader.onload = e => {
      setImageSrc(e.target.result);
      setCropModal(true);
    };
    reader.readAsDataURL(image);
  };

  // When uploaded image is cropped, close modal and set it as file
  const onCrop = async (croppedFile, croppedImageUrl) => {
    setImageCropped(croppedImageUrl);
    setCropModal(false);
    setFile(croppedFile);
  };

  return (
    <div
      className={className}
      style={{ backgroundImage: `url(${imageCropped || currentImage})` }}
      ref={imageRef}
      onClick={() => {
        if (currentImage && !showCropModal) btnRef.current.click();
      }}
    >
      <img src={ImageSVG} className="imageUpload_imageIcon" alt="Upload" />
      <div className="imageUpload_uploader">
        <Button icon="upload" outlined rounded>
          {label}
        </Button>
        <input
          type="file"
          className="imageUpload_input"
          accept="image/jpeg, image/png"
          onChange={onChange}
          ref={btnRef}
        />
      </div>
      <Text superSmall>{notice}</Text>
      <ImageCrop
        show={showCropModal}
        setShow={setCropModal}
        src={imageSrc}
        onCrop={onCrop}
        ratio={420 / 296}
        square
      />
    </div>
  );
};
